module.exports = __webpack_public_path__ + "assets/img/ns.ea2f0476.jpg";